// extracted by mini-css-extract-plugin
export default {"Flash":"use-confirm-delete-field-values-module__Flash--x98vW"};